export default __webpack_public_path__ + "static/media/coopProfile.47e15e72.jpg";